import Home from '@/components/pages/Home'
import ContactUs from '@/components/pages/ContactUs'
import WhyChooseUs from '@/components/pages/WhyChooseUs'
import Services from '@/components/pages/Services'
import PrivacyAndCookiePolicy from '@/components/pages/PrivacyAndCookiePolicy'

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * NOTE: When adding new routes, due to an issue with the vue-prerender
 * plugin, the routes need to be manually added to build/build.js. In
 * there there is a list of URLs to pre-render on deployment.
 *
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */
export default [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/our-services/',
    name: 'our-services',
    component: Services,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/why-choose-us/',
    name: 'why-choose-us',
    component: WhyChooseUs,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/contact-us/',
    name: 'contact-us',
    component: ContactUs,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/privacy-cookie-policy/',
    name: 'privacy-cookie-policy',
    component: PrivacyAndCookiePolicy,
    pathToRegexpOptions: { strict: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js